import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import Typography from "../../../../components/Typography/Typography";
import TypographyInline from "../../../../components/Typography/TypographyInline";
import IconComponent from "../../../../components/Icon/IconComponent";
import { postRequest } from "../../../../Apis/apiWrapper";
import { paymentEndpoints } from "../../../../utils/constants/httpConstants";
import {
  BRAND,
  GREY,
  BASE,
  SUCCESS,
  BORDER,
} from "../../../../utils/constants/colors";
import { fontWeight, ICON_LABELS } from "../../../../utils/constants/UI";
import { EMITTER_ERROR } from "../../../../utils/constants";
import EventEmitter from "../../../../utils/emitter/EventEmitter";
import { INITIAL_ROUTE } from "../../../../utils/constants/routes";
import { checkLogin } from "../../../../redux/actions/authActions";

const OnboardingPaymentSuccess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [verifying, setVerifying] = useState(true);

  const styles = {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
      background: BASE.BACKGROUND,
      padding: "24px",
    },
    card: {
      background: BASE.WHITE,
      borderRadius: "12px",
      padding: "48px",
      maxWidth: "500px",
      width: "100%",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "20px",
      border: `1px solid ${BORDER.DEFAULT}`,
    },
    iconWrapper: {
      width: "80px",
      height: "80px",
      borderRadius: "50%",
      background: SUCCESS.W_50,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    successIcon: {
      fontSize: "40px",
      color: SUCCESS.W_500,
    },
  };

  useEffect(() => {
    const sessionId = searchParams.get("session_id");
    if (sessionId) {
      verifyPayment(sessionId);
    } else {
      // No session ID, just go back to start
      navigate(INITIAL_ROUTE);
    }
  }, []);

  const verifyPayment = async (sessionId) => {
    try {
      setVerifying(true);
      const response = await postRequest(
        navigate,
        paymentEndpoints.verifySession,
        { session_id: sessionId },
      );

      if (response?.data?.status) {
        // Success! Refresh user data and navigate to Step 2 (Account Settings)
        // Refresh Redux without navigate to prevent auto-redirect
        dispatch(checkLogin());

        // Use navigate with state to force the step override in InitialForm
        navigate(INITIAL_ROUTE, { state: { step: 1 } });
      } else {
        EventEmitter.emit(EMITTER_ERROR, "Verification failed. Redirecting...");
        navigate(INITIAL_ROUTE);
      }
    } catch (err) {
      console.error("Error verifying payment:", err);
      EventEmitter.emit(
        EMITTER_ERROR,
        "Failed to verify payment. Redirecting...",
      );
      navigate(INITIAL_ROUTE);
    } finally {
      setVerifying(false);
    }
  };

  return (
    <Box style={styles.container}>
      <Box style={styles.card}>
        <Box style={styles.iconWrapper}>
          <IconComponent
            iconLabel={ICON_LABELS.CHECK_CIRCLE}
            style={styles.successIcon}
          />
        </Box>
        <Typography
          size={"lg"}
          color={GREY.PRIMARY}
          fontWeight={fontWeight.BOLD}
          label="Verifying Payment..."
        />
        <TypographyInline
          size={"sm"}
          color={GREY.SECONDARY}
          fontWeight={fontWeight.REGULAR}
          label="Please wait while we confirm your subscription."
        />
      </Box>
    </Box>
  );
};

export default OnboardingPaymentSuccess;
